import { BaseBudget } from 'typings'
import { useFormStateContext } from 'ui'
import { RegularPromotion } from '../../typings'
import { Summary } from './Summary'
import { Alerts } from './Summary/Alerts'

export function Regular() {
  const { form } = useFormStateContext()

  const {
    conditions,
    general,
    restrictions,
    scheduling,
    regular,
  }: RegularPromotion = form.getValues()

  return (
    <>
      <Alerts>
        <Alerts.RegularRecap regular={regular} />
        <Alerts.AffectedProducts />
      </Alerts>

      <Summary.Container>
        <Summary.Name name={general.name} />
        <Summary.Scheduling scheduling={scheduling} />
        <Summary.SalesChannels salesChannels={restrictions.salesChannels} />
        <Summary.Budget
          budget={restrictions.budget as BaseBudget | undefined}
        />
        <Summary.Sellers sellers={restrictions.sellers} />
        <Summary.Regular benefit={regular.benefit} />
        <Summary.Conditions conditions={conditions} />
        <Summary.Restrictions restrictions={restrictions} />
        <Summary.Accumulate restrictions={restrictions} />
      </Summary.Container>
    </>
  )
}
